import * as React from 'react';

function CheckmarkThinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4 13.5 4.926 4.434a.1.1 0 0 0 .141-.007L20 6",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  }));
}

export { CheckmarkThinIcon };
